import React, { useEffect, useState } from "react";
import "react-datepicker/dist/react-datepicker.css";
import useHttp from "../../../../hook/use-http";
import { Chart } from "react-google-charts";
import NoData_Coral from "../NoData_Coral";
import ChartLoader_Coral from "../ChartLoader_Coral";
import { API_URL_MAIN } from "../../../../constants/driveglobalfilterinitialstates_coral";
import BuketsTable_Coral from "../BuketsTable_Coral";
import * as $ from "jquery";

function DischargeDurErc_Coral({ apiend, gloablfilter, title }) {
  const [chartdata, setChartData] = useState([]);
  const [apiresponce, SetApiResponce] = useState([]);
  const [filteredData, SetfilteredData] = useState([]);
  const { isLoading, error, sendReq: fetchData } = useHttp();
  let modal_title = title;

  const appyData = (data) => {
    const res_result = data;

    let responce = {
      "0-50": 0,
      "50-100": 0,
      "100-150": 0,
      "150-200": 0,
      "200-250": 0,
      "250-300": 0,
      "300-350": 0,
      "350-400": 0,
      "400-450": 0,
      "450-500": 0,
      ">=500": 0,
    };
    if (res_result.length != 0) {
      SetApiResponce(res_result);
      let temp_result = res_result;
      temp_result.map((d) => {
        let value = d._source.dischargeDuration;
        if (value >= 0 && value < 50) {
          responce["0-50"] = responce["0-50"] + 1;
        } else if (value >= 50 && value < 100) {
          responce["50-100"] = responce["50-100"] + 1;
        } else if (value >= 100 && value < 150) {
          responce["100-150"] = responce["100-150"] + 1;
        } else if (value >= 150 && value < 200) {
          responce["150-200"] = responce["150-200"] + 1;
        } else if (value >= 200 && value < 250) {
          responce["200-250"] = responce["200-250"] + 1;
        } else if (value >= 250 && value < 300) {
          responce["250-300"] = responce["250-300"] + 1;
        } else if (value >= 300 && value < 350) {
          responce["300-350"] = responce["300-350"] + 1;
        } else if (value >= 350 && value < 400) {
          responce["350-400"] = responce["350-400"] + 1;
        } else if (value >= 400 && value < 450) {
          responce["400-450"] = responce["400-450"] + 1;
        } else if (value >= 450 && value < 500) {
          responce["450-500"] = responce["450-500"] + 1;
        } else if (value >= 500) {
          responce[">=500"] = responce[">=500"] + 1;
        }
      });

      let res_result_final = [["Element", "Count", { role: "style" }]];
      let loop_keys = Object.keys(responce);
      loop_keys.map((x) => {
        // res_result_final.push([x, responce[x], "#348393"]);
        res_result_final.push([
          x,
          responce[x],
          "stroke-width: 1;stroke-color: black;color:#348393",
        ]);
      });
      setChartData((prestate) => res_result_final);
    } else {
      setChartData((prestate) => []);
      SetApiResponce((prestate) => []);
    }
  };

  const options = {
    hAxis: {
      gridlines: {
        color: "transparent",
      },
      title: "Median Discharge Duration (min)",
      minValue: 0,
      format: "short",
      textStyle: {
        fontSize: 8, // Adjust the font size as needed
      },
      slantedText: true, // Enable slanted text
      slantedTextAngle: 60, // Rotate labels to vertical (90 degrees)
    },
    vAxis: {
      gridlines: {
        color: "transparent",
      },
      title: "Discharge Cycle",
      minValue: 0,
      format: "short",
    },
    // bar: { groupWidth: "90%" },
    bar: { groupWidth: "100%" },
    legend: "none",
  };

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + apiend,
        body: { filterdata: gloablfilter },
      },
      appyData
    );
  }, [gloablfilter]);

  return (
    <>
      <div className="v-title chartbox drive_graph graph_two p-0">
        <div className="titlebg titlebd_drive box_title pb-2 pt-2">{title}</div>
        <div className="chartHGT">
          {isLoading ? (
            <ChartLoader_Coral />
          ) : chartdata.length === 0 ? (
            <NoData_Coral />
          ) : (
            <Chart
              chartType="ColumnChart"
              width="100%"
              height="240px"
              data={chartdata}
              options={options}
            />
          )}
        </div>
      </div>
    </>
  );
}

export default DischargeDurErc_Coral;
